"use client";

import React from "react";
import { Button } from "../common/button";

export interface ProcessStep {
  number: number;
  title: string;
  description: string;
  bgColor?: string;
}

export interface ProcessStepsProps {
  title: string;
  subtitle?: string;
  steps: ProcessStep[];
  ctaText?: string;
  onCtaClick?: () => void;
  showConnectors?: boolean;
}

export function ProcessSteps({
  title,
  subtitle,
  steps,
  ctaText,
  onCtaClick,
  showConnectors = true
}: ProcessStepsProps) {
  const defaultColors = ["#dde3ed", "#fbe4d7", "#dde3ed"];

  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6">
          {title}
        </h2>
        {subtitle && (
          <p className="text-lg text-gray-600 text-center mb-20 max-w-3xl mx-auto">
            {subtitle}
          </p>
        )}
        
        <div className="grid md:grid-cols-3 gap-10 md:gap-16 relative">
          {steps.map((step, idx) => (
            <div key={idx} className="text-center relative">
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6"
                style={{ backgroundColor: step.bgColor || defaultColors[idx % defaultColors.length] }}
              >
                <span className="text-2xl font-bold text-gray-700">{step.number}</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
              
              {/* Connector */}
              {showConnectors && idx < steps.length - 1 && (
                <img 
                  src="https://cdn.prod.website-files.com/6110b06f10260e518f5d3077/6110b1396056a5e6b0bd01f9_Dot%20Wave.svg" 
                  alt="" 
                  className="hidden lg:block absolute left-[calc(100%-3rem)] top-7 w-40 h-20 opacity-100"
                />
              )}
            </div>
          ))}
        </div>
        
        {ctaText && (
          <div className="text-center mt-16">
            <Button size="lg" onClick={onCtaClick}>
              {ctaText}
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Button>
          </div>
        )}
      </div>
    </section>
  );
}